module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Italic-95855802.ttf";